import __request__ from 'routing/request';
/**
 * SAML Assertion Consumer Service (POST binding)
 */
export function postACS(): Promise<unknown> {
    return __request__('POST', '/plugins/org.graylog.plugins.security/saml/acs', null, {}, {
        'Accept': []
    });
}
/**
 * SAML Assertion Consumer Service (Redirect binding)
 */
export function getACS(): Promise<unknown> {
    return __request__('GET', '/plugins/org.graylog.plugins.security/saml/acs', null, {}, {
        'Accept': []
    });
}
/**
 * Initiate SP-initiated SAML login flow
 */
export function initiateLogin(): Promise<unknown> {
    return __request__('GET', '/plugins/org.graylog.plugins.security/saml/login', null, {}, {
        'Accept': []
    });
}
/**
 * SAML Single Logout Service (Redirect binding)
 */
export function getLogout(): Promise<unknown> {
    return __request__('GET', '/plugins/org.graylog.plugins.security/saml/logout', null, {}, {
        'Accept': []
    });
}
/**
 * SAML Single Logout Service (POST binding)
 */
export function postLogout(): Promise<unknown> {
    return __request__('POST', '/plugins/org.graylog.plugins.security/saml/logout', null, {}, {
        'Accept': []
    });
}
